import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseAddItemRequest, UseAddItemData, UseCreateTemplate2Request, UseCreateTemplate2Data } from "@api/@types/activity-template";

export const useAddItem = createApiMutation<UseAddItemData, UseAddItemRequest>({
  mutationFn: (req) => apiClientManager.apis.activityTemplate.addItem(req as UseAddItemRequest),
});

export const useCreateTemplate2 = createApiMutation<UseCreateTemplate2Data, UseCreateTemplate2Request>({
  mutationFn: (req) => apiClientManager.apis.activityTemplate.createTemplate2(req as UseCreateTemplate2Request),
});

export type { UseAddItemRequest, UseAddItemData, UseCreateTemplate2Request, UseCreateTemplate2Data } from "@api/@types/activity-template";
